import { Entity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { TEMPORAL_NAMESPACE_ANNOTATION } from './annotations';

const temporalManageContent = EntityContentBlueprint.make({
  name: 'temporal-manage',
  params: {
    path: '/manage',
    title: 'Manage',
    filter: (entity: Entity) =>
      Boolean(entity.metadata.annotations?.[TEMPORAL_NAMESPACE_ANNOTATION]),
    loader: async () => {
      const { ManageContent } = await import('./ManageContent');
      return <ManageContent />;
    },
  },
});

export const temporalManageModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [temporalManageContent],
});
